import { PREMIUM_SIZES } from '../../utils/pergolaCatalog';
import React, { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const PergolasFAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqItems: FAQItem[] = [
    {
      question: "How much do Toronto pergolas cost?",
      answer: `Premium pergolas start at ${new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 }).format(PREMIUM_SIZES[0].priceCAD)} before tax, with standard installation and delivery included. Premium+ is individually quoted. Special site work and optional extras are priced separately.`
    },
    {
      question: "Do louvered pergolas work in Canadian winters?",
      answer: "Follow the operating and maintenance instructions for your pergola, particularly during snow and freezing weather. Our team can discuss the requirements for your site."
    },
    {
      question: "How long does pergola installation take in Ontario?",
      answer: "Most Toronto pergola installations are completed in 1-2 days by our certified Ontario pergola installers. Premium motorized models with electrical work may take an additional day."
    },
    {
      question: "Do you offer financing for Toronto pergolas?",
      answer: "Financing options are available, subject to approval. Request your project quote to discuss available terms."
    },
    {
      question: "Are your pergolas covered by warranty?",
      answer: "Premium pergolas include a 10-year warranty. Warranty details for Premium+ are provided with your individual proposal."
    },
    {
      question: "What's included with an Ontario pergola installation?",
      answer: "Premium pricing includes the motorized pergola, white perimeter lighting, standard installation and delivery. Screens and other options are additional. Footings, deck reinforcement and other special site work are quoted separately."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-primary mb-4">Frequently Asked Questions</h2>
          <p className="text-xl text-gray-600">Everything you need to know about our pergolas</p>
        </div>

        <div className="space-y-6">
          {faqItems.map((item, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
              >
                <h3 className="text-lg font-semibold text-primary pr-4">
                  {item.question}
                </h3>
                <span className="text-accent text-xl font-bold flex-shrink-0">
                  {openIndex === index ? '−' : '+'}
                </span>
              </button>
              
              <div 
                className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${
                  openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="text-gray-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Help */}
        <div className="mt-16 text-center">
          <div className="bg-white rounded-xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold text-primary mb-4">Still Have Questions?</h3>
            <p className="text-gray-600 mb-6">
              Our pergola experts are here to help you make the right choice for your outdoor space.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/pergola-quote"
                className="bg-accent text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors inline-block"
              >
                Get Pergola Quote
              </a>
              <a
                href="tel:+1234567890"
                className="border-2 border-accent text-accent px-8 py-3 rounded-lg font-semibold hover:bg-accent hover:text-white transition-colors inline-block"
              >
                Call Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PergolasFAQ;
